import React, { FC } from 'react';

import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import SectionContainer from '@common/components/SectionContainer';

import { DatePicker } from './DatePicker';
import {
  StyledHero,
  SolidColorBackground,
  BackgroundWrapper,
  FormWrapper,
  PageTitle,
  PageSubTitle,
  Divider,
  Content,
  OldFormWrapper,
  OldPageTitle,
  SubTitleContent,
  TitleContent,
  StyledSectionContainer,
} from './Hero.styles';
import { HeroProps } from './Hero.types';
import { useModuleStatuses } from '@features/properties';

export const Hero: FC<HeroProps> = ({
  backgroundUrl,
  title,
  property,
  journeyParams,
  showAsMinimalLayout,
}) => {
  const { isTablesIntegrated, isSpaIntegrated } = property;

  const {
    statuses: { isRoomsEnabled },
  } = useModuleStatuses();

  const { homepage } = property;

  function getAlignment(heroContentPosistion: string) {
    switch (heroContentPosistion) {
      case 'left':
        return 'left';
      case 'center':
        return 'center';
      case 'centerAlt':
        return 'centerAlt';
      default:
        return 'left';
    }
  }

  const alignment = getAlignment(homepage?.layoutData?.heroContent);

  const isFiltersVisible =
    (isRoomsEnabled || isTablesIntegrated || isSpaIntegrated) && !showAsMinimalLayout;

  const heroPreHeader = homepage?.layoutData?.heroPreHeader;

  return (
    <BackgroundWrapper
      alignment={showAsMinimalLayout ? alignment : 'left'}
      isFiltersVisible={isFiltersVisible}
      data-testid={`hero-${title.toLowerCase()}`}
    >
      <BackgroundImgixWrapper src={backgroundUrl as string}>
        <StyledHero darkenBackdrop={showAsMinimalLayout}>
          {!backgroundUrl && <SolidColorBackground />}

          {showAsMinimalLayout ? (
            <StyledSectionContainer>
              <FormWrapper alignment={alignment}>
                <TitleContent>
                  <PageTitle alignment={alignment}>{title}</PageTitle>
                </TitleContent>

                {heroPreHeader && (
                  <>
                    <Divider />

                    <SubTitleContent>
                      <PageSubTitle alignment={alignment}>{heroPreHeader}</PageSubTitle>
                    </SubTitleContent>
                  </>
                )}
              </FormWrapper>
            </StyledSectionContainer>
          ) : (
            <SectionContainer>
              <OldFormWrapper>
                <Content>
                  <OldPageTitle>{title}</OldPageTitle>
                </Content>

                <DatePicker
                  journeyParams={journeyParams}
                  isFiltersVisible={isFiltersVisible}
                  property={property}
                  isHomepage
                />
              </OldFormWrapper>
            </SectionContainer>
          )}
        </StyledHero>
      </BackgroundImgixWrapper>
    </BackgroundWrapper>
  );
};
